/**
 * 그려서 받은 그림(Midjourney · FLUX · OpenAI …)을 화면에 잇는다.
 *
 * 매니페스트에는 칸(slot)이 있고 ingest 가 받은 그림을 넣지만, 화면은 오랫동안 매니페스트를
 * 한 번도 읽지 않았다 — 칸을 채워도 게임은 계속 절차적 그림만 그렸다(절대 규칙 11 위반).
 * 여기가 그 연결이다. 그림이 없는 칸은 지금처럼 절차적으로 그려진다: 에셋이 없어도 게임은 돈다.
 *
 * 승인 게이트: 기본 빌드는 `approved` 만 쓴다. 검수용 빌드(`VITE_ART_DRAFTS=1`)만 `draft` 도 쓴다 —
 * 사람이 게임 안에서 보고 승인할 수 있게. 승인은 사람 몫이다(ingest --approve --license, GDD §51).
 */

import manifest from '../../public/art/asset-manifest.json';

interface ManifestEntry {
  readonly id: string;
  readonly status: string;
  readonly path?: string;
}

const SHOW_DRAFTS = import.meta.env.VITE_ART_DRAFTS === '1';

const PRODUCED: ReadonlyMap<string, string> = new Map(
  (manifest.entries as readonly ManifestEntry[])
    .filter(
      (e) =>
        e.path?.startsWith('art/produced/') &&
        (e.status === 'approved' || (SHOW_DRAFTS && e.status === 'draft')),
    )
    .map((e) => [e.id, `${import.meta.env.BASE_URL}${e.path!}`]),
);

/** 칸 id 에 받은 그림이 있으면 그 URL, 없으면 null. */
export function producedArt(assetId: string | undefined): string | null {
  return (assetId && PRODUCED.get(assetId)) || null;
}

/** NPC id(npc.aurelia.tomas) → 초상 칸(portrait.npc.tomas). id 는 바뀌지 않으므로 이름으로 잇지 않는다. */
export function npcPortraitArt(npcId: string): string | null {
  return producedArt(`portrait.npc.${npcId.split('.').pop()}`);
}

/** 몬스터 id(mon.common.caveGoblin · boss.crownwarden) → 몬스터 칸(monster.caveGoblin). */
export function monsterArt(monsterId: string): string | null {
  return producedArt(`monster.${monsterId.split('.').pop()}`);
}
